import { render, staticRenderFns } from "./merchant-application-form.vue?vue&type=template&id=665e741e&lang=pug"
import script from "./merchant-application-form.vue?vue&type=script&lang=js"
export * from "./merchant-application-form.vue?vue&type=script&lang=js"
import style0 from "./merchant-application-form.vue?vue&type=style&index=0&id=665e741e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports